<app-loading [mosTexto]="" *ngIf="loading"></app-loading>
<form [formGroup]="formulario"
      (ngSubmit)="onSubmit()"
      novalidate
      id="fFormularioBienes"
      name="nomFormularioBienes" *ngIf="loading === false">


  <div class="grid mb-3">
    <div class="col-12">
      <h3 class="font-bold uppercase m-0" style="color: #008f39; letter-spacing: 0.5px;">
        {{ 'SEGUROBIENES.LBL_PARAMETROS' | translate }}
      </h3>
    </div>
  </div>

  <div formArrayName="bienesParametros">
    <div *ngFor="let control of bienesArray.controls; let i = index"
         [formGroupName]="i"
         class="grid align-items-center surface-card border-1 border-round border-300 mb-2 p-2" style="margin-top: 8px !important;">

      <div class="col-12 md:col-5 flex align-items-center">

        <span *ngIf="control.get('tipoParametro')?.value !== 'SELECT'"
              class="font-medium text-900">
          {{ control.get('descripcion')?.value }}
        </span>

        <div *ngIf="control.get('tipoParametro')?.value === 'SELECT'" class="w-full div-form">
          <label class="block text-sm mb-1 text-900 font-medium">
            {{ control.get('descripcion')?.value }}
          </label>
          <p-multiSelect [inputId]="'idSelect_' + i" [name]="'nomSelect_' + i"  [options]="control.get('opciones')?.value" filter="filter"
                         defaultLabel="{{ 'LBL_SELECCIONE' | translate}}"
                         selectedItemsLabel="{0} {{ 'LBL_ITEMSELECCIONADO' | translate}}" formControlName="valorSeleccionado"
                         emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                         emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                         optionValue="value"
                         optionLabel="label"
                         styleClass="w-full"
          ></p-multiSelect>
          <div class="p-message p-messages-error p-corner-all" *ngIf="control.get('valorSeleccionado')?.hasError('seleccionRequerida') &&
                (control.get('valorSeleccionado')?.dirty || submitted)">
            {{ control.get('descripcion')?.value }} {{ 'LBL_REQUERIDO' | translate }}
          </div>
        </div>

      </div>

      <div class="col-6 md:col-3 flex align-items-center justify-content-start md:justify-content-center">
        <p-checkbox
          [inputId]="'obligatorio_' + i"
          [name]="'nomObligatorio_' + i"
          formControlName="indicadorObligatorio"
          [disabled]="!control.get('indicadorHabilitado')?.value"
          [binary]="true"
          label="{{ 'SEGUROBIENES.LBL_OBLIGATORIO' | translate }}">
        </p-checkbox>
      </div>

      <div class="col-6 md:col-4 flex align-items-center justify-content-start md:justify-content-end pr-3">
        <span class="mr-2 font-medium text-600">
          {{ 'SEGUROBIENES.LBL_HABILITADO' | translate }}
        </span>
        <p-inputSwitch
          (onChange)="onToggleHabilitado($event, control)"
          [inputId]="'habilitado_' + i"
          [name]="'nomHabilitado_' + i"
          formControlName="indicadorHabilitado">
        </p-inputSwitch>
      </div>

    </div>

  </div>


  <div class="grid form-footer-buttons">
    <div class="form-group col-12">
      <div *ngIf="!guardando">
        <a (click)="onCancelar()" class="cancelar">{{ 'BTN_CANCELAR' | translate }}</a>
        <button icon="fa fa-floppy-o" label="{{'BTN_GUARDAR' | translate }}"
                type="submit"
                pButton></button>
      </div>
      <div *ngIf="guardando">
        <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
        <span>{{'LBL_GUARDANDO' | translate }}</span>
      </div>
    </div>
  </div>

</form>
